module.exports = __webpack_public_path__ + "static/media/gift_3.f7d7e377.png";